// import React from 'react';
// import FeatureCard from '../../../../styles/FeatureCard.js';

// import agent from '../../../../assets/services/vdisolution/icons/enduser.png';
// import AP from '../../../../assets/services/vdisolution/icons/endtoend.png';
// import cloud from '../../../../assets/services/vdisolution/icons/bestdigital.png';
// import support from '../../../../assets/services/vdisolution/icons/support.png';

// const Cards = () => {
//   return (
//     <div className="disastercards disastercards-padding my-0 my-md-4">
//       <div className="disastercards-row">
//         <FeatureCard image={agent} title="Shared and Dedicated Desktops" description="With modern, streamlined approach we deliver Windows or Linux apps and desktops to users quickly and provide users with an interface that is familiar and easy-to-use.
// Individualized Apps. Publish apps on an individual user or group basis. Assigned apps dynamically appear within the users shared desktop without the need for a custom VDI desktop.
// Use Any Device. Access desktops and applications on any device, including tablets, ResoluteOS thin clients, or HTML5 Web browser.
// " />
//         <FeatureCard image={AP} title="Secure Remote Access to Apps and Data" description="We provide a set of features to secure remote access to apps and data no matter where you are, or which device you use. Users can self-manage security via the Virtual Desktop Security Portal, including password and 2FA settings via Inuvika authentication supporting mobile/email/USB secure keys and SAML2 providers (including Duo). It includes an Enterprise Secure Gateway that enables remote access without VPNs or custom security ports and uses modern TLS encryption for secure session communications. Admins can enforce granular user rights controls. It also provides smartcards and biometric device compatibility where supported by Windows applications." />
//       </div>

//       <div className="disastercards-row">
//         <FeatureCard image={cloud} title="Provide secure, zero-trust access to business-critical apps anywhere." description="Mixed Apps Support: Use Windows and Linux apps together, at the same time, within the same user interface and session. You won't have to install extra modules or launch separate sessions to use both. Apps run side-by-side and even share the same resources like clipboard.

// Multi-version Apps: Publish and assign multiple versions of the same app to users or groups that rely on them for specific workflows such as SAP and Microsoft Office.

// Extend the Life of Legacy Apps: That 'one' business app. We all have that one app we need to support. Virtual Desktop gives new life to legacy apps and enables users to access them on modern devices and operating systems.
// " />
//         <FeatureCard image={support} title="Support" description="Follow the Sun-Model - 24/7/365 days support from both On-shore and Off-shore Teams." />
//       </div>
//     </div>
//   );
// };

// export default Cards;


















import React from 'react';
import FeatureCard from '../../../../styles/FeatureCard.js';// Ensure path is correct
import '../../../../styles/disasterCard.css'; // Make sure the new CSS file is imported

// Import your images...
import agent from '../../../../assets/services/vdisolution/icons/enduser.png';
import AP from '../../../../assets/services/vdisolution/icons/endtoend.png';
// import cloud from '../../../../assets/services/vdisolution/icons/bestdigital.png';
import support from '../../../../assets/services/vdisolution/icons/support.png';
import FastDeployment from '../../../../assets/services/backup/icons/FastDeployment.svg';
import ConsistentAndFamiliar from '../../../../assets/services/backup/icons/ConsistentAndFamiliar.svg';
import ProvideSecure from '../../../../assets/services/backup/icons/ProvideSecure.svg';

const Cards = () => {
  const cardData = [
    {
      image: agent,
      title: "Shared and Dedicated Desktops",
      centered: true,
      description: (
        <>
          <p>
            Synectiks delivers Windows and Linux applications and desktops through a modern, streamlined platform that provides users with a familiar, easy‑to‑use interface.
          </p>
          <p>
            Individualized Apps: Publish applications for individual users or groups. Assigned apps dynamically appear within the shared desktop without requiring custom VDI images.
          </p>
          <p>
            Use Any Device: Access desktops and applications from any device, including tablets, ResoluteOS thin clients, or HTML5 browsers.
          </p>

        </>
      )
    },
    {
      image: AP,
      title: "Secure Remote Access to Apps and Data",
      centered: true,
      description: (
        <>
          <p>
            Our platform provides robust security features to protect remote access to applications and data across all devices and locations.
          </p>
          <p>
            Users can self‑manage security settings through the Virtual Desktop Security Portal, including passwords and 2FA options via Inuvika authentication supporting mobile/email/USB keys and SAML2 identity providers (including Duo).
          </p>
          <p>
            An Enterprise Secure Gateway enables remote access without VPNs or custom ports, using modern TLS encryption for secure session communication. Administrators can enforce granular user‑rights controls, and the platform supports smartcards and biometric authentication where compatible with Windows applications.
          </p>
        </>
      )
    },
    {
      image: ProvideSecure,
      title: "Provide secure, zero-trust access to business-critical apps anywhere.",
      centered: true,
      description: (
        <>
          <p>
            Mixed Application Support: Windows + Linux Together: Run Windows and Linux applications side‑by‑side within the same user interface and session - no extra modules or separate sessions required. Apps share resources, including the clipboard.
          </p>
          <p>
            Multi‑Version Apps: Publish multiple versions of the same application for users or groups that rely on specific workflows (e.g., SAP, Microsoft Office).
          </p>
          <p>
            Extend Legacy App Lifespan: Virtual Desktop gives new life to legacy applications, enabling access from modern devices and operating systems.
          </p>

        </>
      )
    },
    {
      image: FastDeployment,
      title: "Fast Deployment and Simplified Management.",
      centered: true,
      description: (
        <>
          <p>
            Unlike legacy VDI solutions that take weeks to configure, Synectiks deploys OVD Enterprise in hours using a single web‑based admin console for centralized management of desktops and applications.
          </p>
          <p>
            A ready‑to‑use proof of concept (PoC) is provided quickly, enabling efficient testing with secure access across all devices.
          </p>
          <p>
            The platform is optimized for LAN, WAN, and internet connections - including low‑bandwidth or high‑latency environments. Adaptive display protocols automatically adjust to network conditions, ensuring a smooth user experience even on mobile networks or remote locations.
          </p>
        </>
      )
    },
    {
      image: ConsistentAndFamiliar,
      title: "Consistent and Familiar User Experience.",
      centered: true,
      description: (
        <>
          <p>
            Synectiks DaaS delivers a smooth, familiar desktop experience that closely mirrors a local Windows or Linux system, reducing the learning curve for end users.
          </p>
          <p>
            Employees access full desktops or individual applications through a simple login, with a consistent interface across browsers, desktops, laptops, thin clients, and mobile devices. Features like session persistence, fast application launch, and seamless reconnection ensure uninterrupted productivity - whether in the office, at home, or on the move.
          </p>
        </>
      )
    },
    {
      image: support,
      title: "Support",
      centered: true,
      description: (
        <p>
          Synectiks DaaS offers flexible support models, including break‑fix resolution, co‑managed IT augmentation, and a fully managed Zero‑Touch service with end‑to‑end ownership of the desktop lifecycle. This reduces operational risk, improves consistency, and enables predictable IT costs.
        </p>
      )
    }
  ];

  return (
    <div className="disastercards-section">
      <div className="disastercards-grid">
        {cardData.map((card, index) => (
          <FeatureCard
            key={index}
            image={card.image}
            title={card.title}
            description={card.description}
            centered={card.centered}
          />
        ))}
      </div>
    </div>
  );
};

export default Cards;